import { useState } from 'react';
import { teamApi } from '../adapters/APIExporter';

interface UseTeamOperationsProps {
  currentUserId?: string;
  onSuccess?: () => void;
}

export const useTeamOperations = ({ currentUserId, onSuccess }: UseTeamOperationsProps = {}) => {
  const [isJoining, setIsJoining] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const joinTeam = async (teamId: string) => {
    if (!currentUserId) {
      throw new Error('User must be logged in to join a team');
    }

    setIsJoining(true);
    setError(null);

    try {
      await teamApi.joinTeam(
        teamId
      );
      onSuccess?.();
      return true;
    } catch (error) {
      setError(error);
      throw error;
    } finally {
      setIsJoining(false);
    }
  };

  return {
    joinTeam,
    isJoining,
    error
  };
};
